export const content = {
  title: "AI Summary",
  disclaimer: {
    // Copy is split so the Privacy Collection Statement renders as an inline link
    lead: "This AI summary is generated to help answer your question and may not always be accurate or complete. Please don't include any personal or sensitive information in your search. Origin handles your personal information in accordance with ",
    linkLabel: "Origin's Privacy Collection Statement",
    linkHref: "https://www.originenergy.com.au/privacy/",
    trail: " for customers and prospective customers.",
  },
  sourcesLabel: "SOURCES",
  feedbackLabel: "Help us improve and rate the relevance of this response.",
  thumbsUpAriaLabel: "This answer was helpful",
  thumbsDownAriaLabel: "This answer was not helpful",
  viewMoreLabel: "View more",
  viewMoreAriaLabel: "View more AI sources",
  sourceSingular: "source",
  sourcePlural: "sources",
  thanksFeedback: "Thank you for your feedback.",
  feedbackError: "Couldn't send feedback — please try again.",
};
